import { Form, FormProps, Input, Radio, Select } from "antd";
import { useEffect } from "react";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import { createRoleAsync } from "../../../store/features/csoManager/role/roleApi";
import { useAppDispatch } from "../../../store/store";
import { ModalType } from "../../../types";
import { RoleData } from "../../../types/csoManager/role";
import { selectSearchOption, StringArrayOption } from "../../../utils/utils";
import FormModal from "../../ui/FormModal";

type Props = {
  open: ModalType;
  handleClose: () => void;
};

export default function CreateNewRole({ open, handleClose }: Props) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const csoRoleData = open?.data as RoleData;
  const onFinish: FormProps<any>["onFinish"] = (values) => {
    dispatch(
      createRoleAsync({
        data: values,
        others: {
          reRender: handleClose,
          id: csoRoleData?._id,
        },
      })
    );
  };

  // add value in modal for view and edit
  useEffect(() => {
    if (open?.type === "VIEW" && csoRoleData?._id) {
      form.setFieldsValue({
        role_name: csoRoleData?.role_name,
        role_type: csoRoleData?.role_type,
        status: csoRoleData?.status,
      });

      // setRegionId(AreaData?.regionId?._id);
    }
  }, [
    csoRoleData?._id,
    csoRoleData?.role_name,
    csoRoleData?.role_type,
    csoRoleData?.status,
    form,
    open?.type,
  ]);

  return (
    <FormModal
      disabled={false}
      open={open?.open}
      hideBtn={open?.type === "VIEW"}
      title={`${open?.type === "ADD" ? "Add new" : "View"} Role`}
      onFinish={onFinish}
      handleClose={handleClose}
      buttonText="Save"
      width={584}
      formProps={{
        form,
      }}
    >
      <div className="grid md:grid-cols-2 sm:grid-cols-1 md:gap-x-4">
        <Form.Item
          name="role_name"
          label="Role Name"
          rules={[
            {
              required: true,
              message: "Please enter full name",
            },
          ]}
        >
          <Input
            size="large"
            placeholder="Enter full name"
            disabled={open?.type === "VIEW"}
          />
        </Form.Item>
        <Form.Item
          name="role_type"
          label="Role Type"
          rules={[
            {
              required: true,
              message: "Please enter address",
            },
          ]}
        >
          <Select
            placeholder="Select"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={StringArrayOption(RoleType)}
            suffixIcon={<SelectDownIcon />}
            disabled={open?.type === "VIEW"}
          />
        </Form.Item>
        <div className="flex items-center">
          <Form.Item name="status" className="hide_margin">
            <Radio.Group
              disabled={open?.type === "VIEW"}
              className="custom-radio"
              //   onChange={(e) => setOwnershipType(e.target.value)}
              //   value={ownershipType}
              size="large"
            >
              {statusList?.map((el, idx) => (
                <Radio
                  className="text-body text-base font-medium leading-7 mr-3.5"
                  value={el}
                  key={idx}
                >
                  {el}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
        </div>
      </div>
    </FormModal>
  );
}

const statusList = ["Active", "Inactive"];
const RoleType = ["admin", "cso", "cso_admin"];
